import { Navigate } from 'react-router-dom';
import { pagesConfig } from '../../../../shared/pages-config';
import { isFeatureEnabled } from '../../../../utils/feature-flags';
import { useUserSettings } from '../../../../utils/use-user-settings';
import SlackIntegrationCard from './slack-integration-card';

import Stack from '@mui/material/Stack';
import SharedTabHeader from '../../../../shared/shared-tab-header';

export default function IntegrationsPage() {
  const { features } = useUserSettings();

  if (!isFeatureEnabled('slackIntegration', features)) {
    return <Navigate to={`/${pagesConfig.settings.link}`} replace />;
  }

  return (
    <Stack gap={2}>
      <SharedTabHeader title="Integrations" />
      <SlackIntegrationCard />
    </Stack>
  );
}
